import { getMsalInstance } from "../auth/msalInstance";

export default class AuthenticationFailureHandler {
  static execute = () => {
    const displayLogin = sessionStorage.getItem("login");
    if (!displayLogin) {
      sessionStorage.setItem("login", "true");
    }
    window.location.href = window.location.origin;
  };

  /*
        Regarding the OAuth state parameter (from oauth.com): When the user is redirected back to your app,
        whatever value you include as the state will also be included in the redirect. This gives your app
        a chance to persist data between the user being directed to the authorization server and back again,
        such as using the state parameter as a session key. This may be used to indicate what action in the
        app to perform after authorization is complete, for example, indicating which of your app’s pages to
        redirect to after authorization.
     */
  static logout = async () => {
    sessionStorage.clear();
    const msalInstance = getMsalInstance();
    if (msalInstance) {
      try {
        await msalInstance.logoutRedirect({
          postLogoutRedirectUri: window.location.origin,
        });
        return;
      } catch {
        // Fallback to URL-based logout below if MSAL logout fails.
      }
    }
    const tenantId = window.EMP?.MSAL_TENANT_ID;
    const tenantIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!tenantId || !tenantIdPattern.test(tenantId)) {
      window.location.assign(window.location.origin);
      return;
    }
    const logoutUrl = new URL(
      `/${tenantId}/oauth2/v2.0/logout`,
      "https://login.microsoftonline.com",
    );
    logoutUrl.searchParams.set(
      "post_logout_redirect_uri",
      window.location.origin,
    );
    window.location.assign(logoutUrl.toString());
  };
}
